import { CreateAccountDto } from '../../dto/createaccount/createaccountdto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';


export interface CreateAccountRequest extends APIRequest
{
    getCreateAccountRequest(): CreateAccountDto;
}

export class CreateAccountRequestImpl extends APIRequestDtoImpl implements CreateAccountRequest
{
    constructor(private createAcccountData: CreateAccountDto)
    {
        super();
    }

    getCreateAccountRequest(): CreateAccountDto
    {
        return this.createAcccountData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/createaccount/createaccountrequest.tsx